import React from "react";
import "../../shared/loader/circularloader.css";
const CircularLoader = () => {
	return (
		<div className="ag-grid-loading-overlay">
			<div className="dot-spinner">
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
				<div className="dot-spinner__dot"></div>
			</div>
		</div>
	);
};

export default CircularLoader;
